import { render, staticRenderFns } from "./SystemSelect.vue?vue&type=template&id=0f8af574&scoped=true&"
import script from "./SystemSelect.vue?vue&type=script&lang=js&"
export * from "./SystemSelect.vue?vue&type=script&lang=js&"
import style0 from "./SystemSelect.vue?vue&type=style&index=0&id=0f8af574&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8af574",
  null
  
)

export default component.exports